import { render, staticRenderFns } from "./WorkspaceDocumentationModal.vue?vue&type=template&id=0b19b685&scoped=true"
import script from "./WorkspaceDocumentationModal.vue?vue&type=script&lang=js"
export * from "./WorkspaceDocumentationModal.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceDocumentationModal.vue?vue&type=style&index=0&id=0b19b685&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b19b685",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b19b685')) {
      api.createRecord('0b19b685', component.options)
    } else {
      api.reload('0b19b685', component.options)
    }
    module.hot.accept("./WorkspaceDocumentationModal.vue?vue&type=template&id=0b19b685&scoped=true", function () {
      api.rerender('0b19b685', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceDocumentationModal.vue"
export default component.exports